import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { StandService } from 'src/app/service/stand.service';
import { ClientService } from 'src/app/service/client.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Stand } from 'src/app/entity/Stand';

@Component({
  selector: 'app-stands-client',
  templateUrl: './stands-client.component.html',
  styleUrls: ['./stands-client.component.css']
})
export class StandsClientComponent implements OnInit,OnChanges {

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    this.clientService.findStandsClient(this.idClient).subscribe(result=>{
      this.stands=result;
      this.metrage=0;
      this.stands.forEach(element => {
        this.metrage+=element.superficie;
      
      });
      this.metrageS=this.metrage+" m²";
      })
  }
@Input() idClient:number;
stands:Stand[];
metrage:number;
metrageS:string;
  constructor(private router:Router,private clientService:ExhibitorService) { 


  }

  ngOnInit() {

  }
  gogtoDetail(){
    //console.log('this.idClient'+this.idClient  );
  this.router.navigateByUrl(`/add-exhibitor/${this.idClient}/2`  )  
  }





}
